import "./index.css"
import React from 'react';
import { Link } from "react-router-dom";
import Header from "../header"
import studentnewhome from "../../assests/images/studentnewhome.png"
import ServiceCards from "../servicecard";
//import CountriesCards from "../countriescard";
import CountriesCarousel from "../countirescaurosal";
import TaskBar from "../taskbar";
import CopyRight from "../copyright";


const Home = () => {
//   const [data, setData] = useState(null);
 // const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

  return (
    <>
    <div className="home-container">
    <Header />
    <div className="hero-horizontal" style={{ background: 'linear-gradient(to right, #002F6C, #00B8E6)' }}>
      <div className="hero-text-horizontal">
        <p>
          Your Dreams, Our Mission — Since 2013 At Dream Destination Abroad, we believe every student deserves the chance to turn their global education dreams into reality. With over a decade of trusted expertise, we provide seamless admission guidance, fast-track application processing, and complete support from start to finish.
          Whether you're just exploring options or ready to apply — we're here to make your journey smooth, successful, and stress-free. Let us turn your aspirations into achievements.
        </p>
        <Link to="/applynow" className="hero-btn" style={{backgroundColor: "#FFFF00", color: "blue", fontWeight: "bold"}}>
          Book Free Demo
        </Link>
      </div>
      <div className="hero-image-horizontal">
        <img src={studentnewhome} alt="Student" />
      </div>
    </div>
    <h2 style={{textAlign: "center"}}>Our Services</h2>
    <p style={{textAlign: "center"}}>Dream Global. Study Abroad. We Make It Happen.</p>
    <ServiceCards />
    <h2 style={{textAlign: "center"}}> Countries We Cover</h2>
    <CountriesCarousel />
    <div className="apply-online-container">
      <h2 className="apply-online-quote">Ready to chase your dreams?</h2>
      <Link className="apply-online-button" to='applynow'>
        Book Free Demo Now
        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
        </svg>
      </Link>
    </div>
     < TaskBar />
     <CopyRight />
    </div>
    </>
    
  );
};

export default Home;
